import { useQuery } from 'react-query';

import { getProductScope } from '@discover-frontend/utils';
import { useAudienceActivationContext } from 'src/modules/audience-activation/providers/AudienceActivationProvider';
import { QUERY_KEYS } from '../constants';
import { fetchTargets, TARGET_MESSAGE_CODE } from '../request';

export const useFetchTargets = (isOpen: boolean) => {
  const { runId } = useAudienceActivationContext();
  const scope = getProductScope();

  const { isLoading, data, error } = useQuery({
    queryKey: [QUERY_KEYS.GET_TARGETS, runId, scope],
    queryFn: () => fetchTargets(runId, scope),
    enabled: isOpen && !!runId,
  });

  return {
    data: data ?? {
      targetCount: 0,
      message: '',
      code: TARGET_MESSAGE_CODE.SUCCESS,
    },
    isLoading,
    error,
  };
};
